<template>
  <section class="mt-4 px-14 sm-max:px-5 pb-6">
    <div class="mt-16 sm-max:mt-0 space-y-5 md-max:pt-0">
      <div class="lg:text-21 md:text-lg text-base lg:leading-7 leading-5" v-html="text6"></div>
      <div class="lg:text-21 md:text-lg text-base" v-html="text7"></div>
      <div class="!mt-3 lg:text-21 md:text-lg text-base lg:leading-7 leading-5" v-html="text8"></div>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  text6: {
    type: String,
    default: 'What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor.',
  },
  text7: {
    type: String,
    default: 'The best tasting coffee, it turns out, is also the healthiest coffee.',
  },
  text8: {
    type: String,
    default: 'The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen.',
  },


  buttonText:{
    type: String,
    default: 'Save 50% Now',
  }
})

defineBuilderComponent({
    friendlyName: "AboutText",
    canHaveChildren: true,
    inputs: [
        {
            name: "text6",
            type: "richText",
            defaultValue: "What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor."
        },
        {
            name: "text7",
            type: "richText",
            defaultValue: "The best tasting coffee, it turns out, is also the healthiest coffee."
        },
        {
            name: "text8",
            type: "richText",
            defaultValue: "The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen."
        }
    ]
});
</script>